<template>
    <v-flex class="mytools">
        <v-flex v-if="linksExists || canViewSpeakerAdminDirectory">
            <administrator-tools :show-hide-tools="showHideTools"></administrator-tools>
        </v-flex>
        <v-flex>
            <PoliciesTerms class="ma-2" :show-hide-tools="showHideTools"></PoliciesTerms>
        </v-flex>
        <v-flex>
            <ShareYourIdeas :show-hide-tools="showHideTools"></ShareYourIdeas>
        </v-flex>
        <v-flex>
            <ResourceDirectory :show-hide-tools="showHideTools"></ResourceDirectory>
        </v-flex>
        <v-flex>
            <MyLearning v-if="learnerCommunityLink"></MyLearning>
        </v-flex>
        <v-card class="panelBlock ma-2">
            <v-layout row wrap class="panelBlock__cont">
                <v-flex xs12 tag="h2">{{myToolsConstants.RESOURCES}} </v-flex>
                <resources :show-hide-tools="showHideTools"></resources>

            </v-layout>
        </v-card>
    </v-flex>
</template>

<script>
    import { myToolsConstants } from "./mytools.constant.js";
    import { mapActions, mapGetters, mapMutations } from "vuex";
    import { storeGetters } from '../../store/storeGetters.constant';
    import { storeAction } from '../../store/storeActions.constant';
    import { storeMutation } from '../../store/storeMutations.constant.js';
    import Resources from "./Resources";
    import ShareYourIdeas from "./ShareYourIdeas";
    import AdministratorTools from "./AdministratorTools";
    import PoliciesTerms from "../Tools/QuickLinks/PoliciesAndTerms";
    import ResourceDirectory from "../ResourceDirectory/ResourceDirectoryTile";
    import MyLearning from "../ResourceDirectory/MyLearning";
    import { roles } from "../appCommon.constants";


    export default {
        name: "MyTools",
        data: () => ({
            myToolsConstants,
            dialogState: {
                dialogOpen: false,
            },
        }),
        props: {
            showHideTools: {
                type: Function,
            },
        },
        components: {
            Resources,
            AdministratorTools,
            PoliciesTerms,
            MyLearning,
            ResourceDirectory,
            ShareYourIdeas,
        },
        created() {
            this.getCanViewSpeakerAdminDirectory();
        },
        methods: {
            ...mapActions({
                getCategoryLinks: `tools/${storeAction.getCategoryLinks}`,
                getCanViewSpeakerAdminDirectory: `speaker/${storeAction.getCanViewSpeakerAdminDirectory}`,
            }),
            ...mapMutations({
                getFreshQuickLinks2: `tools/${storeMutation.getFreshQuickLinks2}`,
            }),
        },
        computed: {
            ...mapGetters({
                currentUserId: `memberProfile/${storeGetters.currentUserId}`,
                profileInformation: `myAccount/${storeGetters.profileInformation}`,
                prpRole: `chapterWaiver/${storeGetters.prpRole}`,
                canViewSpeakerAdminDirectory: `speaker/${storeGetters.canViewSpeakerAdminDirectory}`,
                isPRPAdmin: `chapterWaiver/${storeGetters.isPRPAdmin}`,
                isPRPMember: `chapterWaiver/${storeGetters.isPRPMember}`,
            }),
            linksExists() {
                return !!((this.profileInformation && (this.profileInformation.salesforceAccessfromExchange ||
                    this.profileInformation.cventAccessfromExchange))
                    || (this.prpRole && (this.isPRPAdmin || this.isPRPMember)));
            },
            learnerCommunityLink() {
                 return (this.profileInformation && (this.profileInformation.lmsAccessFromConnect || 
                 (this.profileInformation.recordTypeName === roles.CHAPTER_ADMINISTRATOR 
                 || this.profileInformation.recordTypeName === roles.CHAPTER_MANAGER 
                 || this.profileInformation.recordTypeName === roles.TEAM_MEMBER 
                 || this.profileInformation.recordTypeName === roles.MEMBER 
                 || this.profileInformation.recordTypeName === roles.SPOUSE_PARTNER)));
            },
        },
    };
</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .mytools {

        &__edit-icon {
            color: $ypo_blue;
        }
    }

    .quick-links-popup {
        overflow: hidden;

        h2 {
            background: $ypo-medium-gray;
            padding: 10px 0 10px 20px;
            color: $ypo-blue;
            font-weight: 500;
            position: relative;

            .v-btn {
                position: absolute;
                right: 0;
                top: 3px;
            }
        }
    }
</style>
